import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EmployeeMismatch = ({ onSync, syncing }: { onSync: () => void; syncing: boolean }) => {
  return (
    <>
      <Box gap="s4" flexDirection="row">
        <Icon.Medium icon="alert-circle-line" color="radicalRed1000" />
        <Text.Header2>
          {i18n.t(
            'payroll_integrations.incidences.datev_lauds.personal_data.error.employee_mismatch_title'
          )}
        </Text.Header2>
      </Box>
      <Text.Normal>
        {i18n.t(
          'payroll_integrations.incidences.datev_lauds.personal_data.error.employee_mismatch_message'
        )}
      </Text.Normal>
      <Button onClick={onSync} disabled={syncing} type="secondary">
        {i18n.t('payroll_integrations.incidences.datev_lauds.personal_data.error.retry')}
      </Button>
    </>
  )
}

export default EmployeeMismatch
